import React, {Component} from 'react';
import {Container} from './styles';
import {FiChevronDown} from 'react-icons/fi';
import {IoMdClose} from 'react-icons/io';
import Modal from 'react-modal';
import ModalSelect from './modalSelect';
import Relogio from '../../../assets/emojis/relogio/relogio@3x.png'

const entrada = {
    overlay: {
        position: 'fixed',
        zIndex: 21,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.03)',
      },
      content: {
        borderWidth: '0px',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-140%, -50%)',
        width: '100%',
        maxWidth: '322px',
        height: '100%',
        maxHeight: '756px'
      }
  };

const saida = {
    overlay: {
        position: 'fixed',
        zIndex: 21,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.03)',
      },
      content: {
        borderWidth: '0px',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-70%, -50%)',
        width: '100%',
        maxWidth: '322px',
        height: '100%',
        maxHeight: '756px'
      }
  };

  const mobile = {
    overlay: {
        position: 'fixed',
        zIndex: 21,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
      },
      content: {
        borderWidth: '0px',
        borderRadius: '8px',
        padding: '0px',
        position: 'fixed',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -42%)',
        width: '100%',
        maxWidth: '360px',
        height: '85%',
      }
  };

export default class HorarioModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            clique: false,
            tipo: '',
            isOpen: false,
            turno: props.turno,
            id: props.id,
            entrada: 'Selecione',
            saida: 'Selecione',
            windowWidth: window.innerWidth
        }
    }

    handleResize = (e) => {
        this.setState({ windowWidth: window.innerWidth });
    }

    componentDidMount() {
        Modal.setAppElement('body');
        window.addEventListener("resize", this.handleResize)
    }

    componentWillUnmount() {
        window.addEventListener("resize", this.handleResize)
    }

    controllerModal(estado, clique, tipo){
        if (clique !== undefined) {
            this.setState({
                clique: clique,
            });
        }
        if (tipo !== undefined) {
            this.setState({
                tipo: tipo,
            });
        }
        this.setState({
            isOpen: !estado,
        });
      }

    setHorario(tipo, horario) {
        if (tipo === 'entrada') {
            this.setState({
                entrada: horario
            })
        }
        if (tipo === 'saida') {
            this.setState({
                saida: horario
            })
        }
        this.setState({
            isOpen: false,
        });
    }

    render() {
        return (
            <Container>
                <Modal
                isOpen={this.state.isOpen}
                // onAfterOpen={this.controllerModal(this.state.isOpen)}
                onRequestClose={() => this.controllerModal(this.state.isOpen)}
                closeModal={() => this.controllerModal(this.state.isOpen)}
                shouldCloseOnEsc={true}
                shouldCloseOnOverlayClick={true}
                closeTimeoutMS={200}
                style={this.state.windowWidth > 930  ? (this.state.clique ? entrada : saida) : mobile}
                contentLabel="Modal"
                >
                        <ModalSelect
                            tipo={this.state.tipo}
                            entrada={this.state.entrada}
                            saida={this.state.saida}
                            selecionar={(tipo, horario) => this.setHorario(tipo, horario)}
                            closeModal={() => this.controllerModal(this.state.isOpen)}/>
                </Modal>
                <div className="close">
                    <button 
                        onClick={() => this.props.closeModal()}>
                        <IoMdClose color="#fff" className="i-close" />
                    </button>
                </div>
                <div className="header">
                    <img alt="" className="emoji" src={Relogio} />
                    <h1>Adicione os horários de entrada e saída do {this.state.turno} turno</h1>
                </div>
                <div className="entrada-saida">
                    <div
                        onClick={() => this.controllerModal(this.state.isOpen, true, 'entrada')} 
                        className="horario">
                        <div className="turno-aberto">
                            <div className="left">
                                <h5>Entrada</h5>
                                <h4>{this.state.entrada}</h4>
                            </div>
                            <FiChevronDown color={'#000000'} size={24} className="chevron"/>
                        </div>
                    </div>
                    <div
                        onClick={() => this.controllerModal(this.state.isOpen, false, 'saida')}  
                        className="horario">
                        <div className="turno-aberto">
                            <div className="left">
                                <h5>Saída</h5>
                                <h4>{this.state.saida}</h4>
                            </div>
                            <FiChevronDown color={'#000000'} size={24} className="chevron"/>
                        </div>
                    </div>
                </div>
                <div className="botao">
                    <button 
                        onClick={() => (this.state.entrada && this.state.saida) !== 'Selecione' ? this.props.salvar(this.state.id, this.state.turno, this.state.entrada, this.state.saida) : null}
                        className="salvar">Salvar alterações</button>
                </div>
            </Container>
        )
    }
}